import React, { useEffect, useState } from 'react';
const salesData = [{
  province: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  province: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  province: 'Mendoza',
  time: 'hace 8 minutos'
}, {
  province: 'Rosario, Santa Fe',
  time: 'hace 12 minutos'
}, {
  province: 'Tucumán',
  time: 'hace 15 minutos'
}, {
  province: 'Mar del Plata, Buenos Aires',
  time: 'hace 18 minutos'
}, {
  province: 'Salta',
  time: 'hace 22 minutos'
}, {
  province: 'Neuquén',
  time: 'hace 25 minutos'
}, {
  province: 'La Plata, Buenos Aires',
  time: 'hace 30 minutos'
}, {
  province: 'San Juan',
  time: 'hace 35 minutos'
}, {
  province: 'Misiones',
  time: 'hace 40 minutos'
}, {
  province: 'Entre Ríos',
  time: 'hace 45 minutos'
}, {
  province: 'Chaco',
  time: 'hace 50 minutos'
}, {
  province: 'San Luis',
  time: 'hace 55 minutos'
}];
const names = ['María', 'Lucía', 'Camila', 'Valentina', 'Sol', 'Florencia', 'Agustina', 'Martina', 'Julieta', 'Carolina', 'Rocío', 'Milagros', 'Daniela', 'Paula', 'Sofía'];
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    // First popup after 8 seconds
    const initialDelay = setTimeout(() => {
      if (!dismissed) {
        setVisible(true);
      }
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    // Hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    // Show next one after hiding (4s visible + random 12-20s pause)
    const nextTimer = setTimeout(() => {
      if (!dismissed) {
        setCurrentIndex(prev => (prev + 1) % salesData.length);
        setVisible(true);
      }
    }, 4000 + 12000 + Math.random() * 8000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, currentIndex, dismissed]);
  if (dismissed) return null;
  const sale = salesData[currentIndex];
  const name = names[currentIndex % names.length];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-[280px] transition-all duration-500 ease-in-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-151">
      <div className="bg-[#1a1a1a] border border-[rgba(212,175,55,0.25)] rounded-xl p-3 shadow-[0_8px_30px_rgba(0,0,0,0.5)] flex items-start gap-2.5" data-id="element-152">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-dorado to-oro-rosa flex items-center justify-center text-[14px] flex-shrink-0" data-id="element-153">
          🛒
        </div>
        <div className="flex-1 min-w-0" data-id="element-154">
          <p className="text-blanco text-[12px] leading-[1.4] m-0" data-id="element-155">
            <span className="font-bold text-dorado" data-id="element-156">{name}</span> de{' '}
            <span className="text-oro-rosa-claro" data-id="element-157">{sale.province}</span> compró{' '}
            <span className="font-semibold" data-id="element-158">Efecto Diamante</span>
          </p>
          <p className="text-[#666] text-[10px] mt-0.5 m-0" data-id="element-159">{sale.time}</p>
        </div>
        <button onClick={() => setDismissed(true)} className="text-[#555] hover:text-[#999] text-[14px] leading-none cursor-pointer bg-transparent border-none p-0 flex-shrink-0" aria-label="Cerrar notificación" data-id="element-160">
          ✕
        </button>
      </div>
    </div>;
}